import { render, staticRenderFns } from "./SandboxUserMessage.vue?vue&type=template&id=0c57f41e&scoped=true&"
import script from "./SandboxUserMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./SandboxUserMessage.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SandboxUserMessage.vue?vue&type=style&index=0&id=0c57f41e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c57f41e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c57f41e')) {
      api.createRecord('0c57f41e', component.options)
    } else {
      api.reload('0c57f41e', component.options)
    }
    module.hot.accept("./SandboxUserMessage.vue?vue&type=template&id=0c57f41e&scoped=true&", function () {
      api.rerender('0c57f41e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/sandbox/SandboxUserMessage.vue"
export default component.exports